/* lua.js generated code 0.3.0 */
let UserNewReward = require("clover/logic/userTask/UserNewReward")
var PushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var NewUserRewardPanel = xClass("NewUserRewardPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/new_user_reward_panel_newRewardPanel.csb")
})
function getPlatformTitle() {
    return table([1, "name", ""], [1, "title", "新手礼包"])
}
var panelOffset = 0
NewUserRewardPanel.show = function (onCloseCallback, onSuccess) {
    function success() {
        let panel = NewUserRewardPanel.create(onCloseCallback)
        if (onSuccess) {
            onSuccess(panel)
        } else {
            panel.popup(true)
        }
    }
    preloadWithLoading(["packed/NewUserRewardPanelRes.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
        setTimeout(() => {
            onCloseCallback && onCloseCallback()
        }, 0);
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        setTimeout(() => {
            onCloseCallback && onCloseCallback()
        }, 0);
    })
}
NewUserRewardPanel.prototype.itemPos = table([1, 2, table(
    [1, 1, table([0, 127 + 60], [0, -257])],
    [1, 2, table([0, 305 + 60], [0, -257])]
)], [1, 3, table(
    [1, 1, table([0, 57 + 60], [0, -437])],
    [1, 2, table([0, 216 + 60], [0, -437])],
    [1, 3, table([0, 375 + 60], [0, -437])]
)], [1, 4, table(
    [1, 1, table([0, 55 + 50], [0, -440])],
    [1, 2, table([0, 167 + 50], [0, -440])],
    [1, 3, table([0, 280 + 50], [0, -440])],
    [1, 4, table([0, 392 + 50], [0, -440])]
)])
NewUserRewardPanel.prototype.itemScale = table([1, 1, table(0.60, 0.79)], [1, 2, table(0.60, 0.79)], [1, 3, table(0.55, 0.72)], [1, 4, table(0.5, 0.65)])
NewUserRewardPanel.createMixedTitle = function (config) {
    var titleNode = cc.Node.create()
    var nameNode = cc.Node.create()
    nameNode.setAnchorPoint(0, 0)
    nameNode.setPosition(0, 0)
    titleNode.addChild(nameNode)
    var nameLength = 0
    var maxHeight = 0
    if (config.name) {
        var $st11 = string.gfind(tostring(config.name), "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
        while (1) {
            var t = $st11[0]($st11[1], $st11[2])
            var xchar = t[0]
            if (xchar == null) break
            $st11[2] = xchar
            var fontName
            var offsetY = 0
            if (string.match(xchar, "[0-9A-Za-z]")) {
                fontName = "font/berlinsansfb_50_whitestroke_blue.fnt"
                offsetY = 5
            } else {
                fontName = "font/zzgftongxin_40_whitestroke_blue.fnt"
            }
            var bmLabel = ccui.TextBMFont.create(xchar, fontName)
            bmLabel.setAnchorPoint(0, 0)
            bmLabel.setPosition(nameLength, (config.offsetY || 0) + (offsetY || 0))
            nameNode.addChild(bmLabel)
            var size = bmLabel.getContentSize()
            if (size.height > maxHeight) {
                maxHeight = size.height
            }
            nameLength = nameLength + size.width - 2
        }
        nameLength = nameLength + 5
    }
    nameNode.setContentSize(cc.size(nameLength, maxHeight))
    var titleLabel = ccui.TextBMFont.create(config.title, "font/zzgftongxin_40.fnt")
    titleLabel.setColor(UILabelColor.kBrown)
    titleLabel.setAnchorPoint(0, 0)
    titleLabel.setPosition(nameLength, 0)
    titleNode.addChild(titleLabel)
    var size = titleLabel.getContentSize()
    if (size.height > maxHeight) {
        maxHeight = size.height
    }
    var totalLength = nameLength + size.width
    titleNode.setContentSize(cc.size(totalLength, maxHeight))
    return titleNode
}
NewUserRewardPanel.prototype.ctor = function (onCloseCallback) {
    var self = this
    if (META.platform == XcloverPlatform.wechatgame) {
        let um = UserManager.getInstance()
        self.isOpening = um.getSettingByKey('wechatGroupShareRewards')
        self.canShare = um.getSettingByKey('wechatGroupShareRewardsCanShare')
    }
    self.onCloseCallback = onCloseCallback
    self.infiniteEnergyIcon = null
    self.rewardItems = table()
    self.init()
}
NewUserRewardPanel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)
    self.setScale(self.getReferenceScale())


    var title = getPlatformTitle()
    var titleLabel = NewUserRewardPanel.createMixedTitle(title)
    titleLabel.setAnchorPoint(cc.p(0.5, 0.5))
    titleLabel.setPosition(275, -130)
    self.addChild(titleLabel)

    var btn = self.getChildByName("getbtn")

    var newReward
    if (self.isOpen()) {
        if (self.B()) {
            // 去掉奶瓶，面板大小需要调整
            let bg = self.getChildByName("bg")

            self.height -= 150
            bg.height -= 150
            self.getChildByName("desc").setVisible(false)
            self.getChildByName("energybg").setVisible(false)
            newReward = $table([{ "itemId": 10006, "num": 1 }, { "itemId": 14, "num": 10 }])
            var rewardCount = $len(newReward)
            var $limit27 = rewardCount
            for (var i = 1; i <= $limit27; i += 1) {
                var config = newReward[i]
                self.createRewardItem(i, config, rewardCount)
            }

            btn.setPositionY(btn.getPositionY() + 150)
        } else {
            newReward = $table([{ "itemId": 22, "num": 1 }, { "itemId": 10006, "num": 1 }, { "itemId": 14, "num": 10 }])
            self.itemPos = table([1, 2, table(
                [1, 1, table([0, 127 + 60], [0, -437])],
                [1, 2, table([0, 305 + 60], [0, -437])]
            )])
            self.createInfiniteEnergy(newReward[1])
            var rewardCount = $len(newReward) - 1
            var $limit27 = rewardCount
            for (var i = 1; i <= $limit27; i += 1) {
                var config = newReward[i + 1]
                self.createRewardItem(i, config, rewardCount)
            }
        }
    } else {
        newReward = MetaManager.getInstance().getNewUserRewards()
        self.createInfiniteEnergy(newReward[1])
        var rewardCount = $len(newReward) - 1
        var $limit27 = rewardCount
        for (var i = 1; i <= $limit27; i += 1) {
            var config = newReward[i + 1]
            self.createRewardItem(i, config, rewardCount)
        }
    }
    self.config = newReward
    var label = btn.getChildByName("label")
    label.setAnchorPoint(cc.p(0.5, 0.5))
    label.setPosition(52, -5)
    label.setString(getText("Newpacks.get"))
    self.getbtn = UIGroupButton.create(btn)
    PushBounceIdleBubbleAnim.create(self.getbtn)
    self.getbtn.on(UIButtonEvent.Click, function () {
        self.getReward()
    })
}
NewUserRewardPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
}
NewUserRewardPanel.prototype.createInfiniteEnergy = function (config) {
    var self = this
    var bottlePosX = 150
    var bottlePosY = -270
    var num = config.num
    var areabg = cc.Sprite.createWithSpriteFrameName("new_user_reward_panel/infiniteBottle.png")
    areabg.setPosition(bottlePosX, bottlePosY)
    var clipNode = cc.ClippingNode.create(areabg)
    clipNode.setPosition(0, 0)
    clipNode.setAlphaThreshold(0.5)
    self.addChild(clipNode)
    var layer = cc.LayerColor.create(cc.c4b(212, 164, 111, 255), 200, 200)
    layer.setPosition(bottlePosX - 100, bottlePosY - 100)
    clipNode.addChild(layer)
    var icon = cc.Sprite.createWithSpriteFrameName("new_user_reward_panel/infiniteBottle.png")
    icon.setPosition(bottlePosX, bottlePosY)
    self.addChild(icon, 5)
    var numText = UIItemBuilder.createItemNumber(num)
    numText.setPosition(80, 20)
    numText.setScale(1.2)
    icon.addChild(numText, 10)
    var descText = self.getChildByName("desc")
    descText.setString(getText("prop.desc.10021"))
    self.infiniteEnergyIcon = icon
    self.infiniteEnergyNumber = numText
}
NewUserRewardPanel.prototype.createRewardItem = function (index, config, rewardCount, scale) {
    var self = this
    var itemId = config.itemId
    scale = scale || 1
    var num = config.num
    var [posX, posY] = [self.itemPos[rewardCount][index][1], self.itemPos[rewardCount][index][2]]
    var bg = cc.Sprite.createWithSpriteFrameName("uilibrary/second_board.png")
    bg.setScale(self.itemScale[rewardCount][1] * scale, self.itemScale[rewardCount][2] * scale)
    bg.setPosition(posX, posY)
    self.addChild(bg)
    var icon = UIItemBuilder.createProp(itemId, num, 0, true)[0]
    icon.setScale(self.itemScale[rewardCount][1] * 1.25)
    icon.setPosition(posX, posY)
    self.addChild(icon, 5)
    self.rewardItems[index] = icon
}
NewUserRewardPanel.prototype.getReward = function () {
    var self = this
    self.getbtn.setEnabled(false)
    if (self.isOpen()) {
        DCAssist.userTrack("newUserGiftbag", "click_receive_btn")

        if (self.canShare) {
            // 可以群分享加倍，弹面板
            var GameGiftPanel = require("clover/panel/NewUserRewardWxSharePanel")
            var panel = GameGiftPanel.create(function () {
                setTimeout(function () {
                    self.getbtn.setEnabled(true)
                    for (var k = 1, v = self.config[1]; v; k++ , v = self.config[k]) {
                        UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.NEW_USER_WX_SHARE)
                    }
                    self.playItemAnimation(function () {
                        self.onClose()
                    })
                }, 600)
            })
            panel.popup()
        } else {
            // 直接领取微信平台礼包
            UserNewReward.getInstance().getNewUserRewardsWx(function () {
                for (var k = 1, v = self.config[1]; v; k++ , v = self.config[k]) {
                    UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.NEW_USER_WX_SHARE)
                }
                self.playItemAnimation(function () {
                    self.onClose()
                })
            }, function (error) {
                Toast.make("网络异常请重试", null, function () {
                    self.closing = false
                })
            })
        }
    } else {
        UserNewReward.getInstance().getNewUserRewards(function () {
            self.playItemAnimation(function () {
                self.onClose()
            })
        }, function (error) {
            // TODO: deal with error
            self.onClose()
        })
    }
}
NewUserRewardPanel.prototype.playItemAnimation = function (onAnimFinish) {
    var self = this
    //move icon to world
    var scene = cc.Director.getInstance().getRunningScene()
    var layer = cc.Layer.create()
    scene.addChild(layer, 1100)
    if (self.infiniteEnergyIcon) {
        var { x: posX, y: posY } = self.infiniteEnergyIcon.getPosition()
        var worldPos = self.convertToWorldSpace(cc.p(posX, posY))
        var targetPos = require("clover/scene/HomeScene").getInstance().getEnergyPosition()
        self.infiniteEnergyIcon.retain()
        self.infiniteEnergyIcon.removeFromParent(false)
        self.infiniteEnergyIcon.setPosition(worldPos.x, worldPos.y)
        layer.addChild(self.infiniteEnergyIcon)
        var infiniteEnergyNumber = self.infiniteEnergyNumber
        var bezierConfig = table(
            [0, cc.p(worldPos.x - 200, worldPos.y + 50)],
            [0, cc.p(targetPos.x - 200, targetPos.y - 50)],
            [0, targetPos]
        )
        self.infiniteEnergyIcon.runAction(cc.Sequence.create(cc.ScaleTo.create(0.3, 1.64), cc.ScaleTo.create(0.3, 0.95), cc.Spawn.create(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(onAnimFinish)), cc.BezierTo.create(0.4, bezierConfig), cc.ScaleTo.create(0.4, 0.45)), cc.CallFunc.create(function () {
            infiniteEnergyNumber.runAction(cc.FadeOut.create(0.2))
        }), cc.Spawn.create(cc.FadeOut.create(0.2), cc.ScaleTo.create(0.2, 1)), cc.CallFunc.create(function () {
            layer.removeFromParent(true)
        })))
    }
    var flyItemConfig = table()
    var $limit62 = $len(self.rewardItems)
    for (var i = 1; i <= $limit62; i += 1) {
        self.rewardItems[i].setVisible(false)
        var config = table()
        let index = i
        if (self.infiniteEnergyIcon) {
            index = i + 1
        }
        config.itemId = self.config[index].itemId
        config.num = self.config[index].num
        config.pos = self.convertToWorldSpace(cc.p(self.rewardItems[i].getPosition()))
        table.insert(flyItemConfig, config)
    }
    if (self.infiniteEnergyIcon) {
        HomeSceneAnimation.playGetPropAnimation(flyItemConfig, null, 0.15)
    } else {
        HomeSceneAnimation.playGetPropAnimation(flyItemConfig, onAnimFinish, 0.15)
    }

}
NewUserRewardPanel.prototype.remove = function (cleanup) {
    var self = this
    cc.log("NewUserRewardPanel:remove()")
    self.onExitAnimStart()
    var vSize = cc.Director.getInstance().getVisibleSize()
    PanelScaleAnim.remove(self, 0.3, cc.p(vSize.width / 2, vSize.height / 2), function () {
        PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup)
    })
}
NewUserRewardPanel.prototype.onClose = function () {
    var self = this
    if (self.onCloseCallback) {
        self.onCloseCallback()
    }
    BasePanel.prototype.onClose.call(self)
}

NewUserRewardPanel.prototype.B = function () {
    var self = this
    let uid = UserManager.getInstance().uid
    return !(uid % 2) && self.isOpening
    // return true
}

NewUserRewardPanel.prototype.isOpen = function () {
    var self = this
    return self.isOpening
    // return true
}
NewUserRewardPanel.prototype.onKeyBackClicked = function () { }
module.exports = NewUserRewardPanel
